module.exports = __webpack_public_path__ + "static/media/02.5cdf8e75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/community/02.jpg
// module id = 21
// module chunks = 0